import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/')({
	beforeLoad: () => {
		throw redirect({ to: '/$entity/', params: { entity: 'users' } })
	},
	// Platzhalter-Komponente; die Weiterleitung wird bereits in beforeLoad ausgefuehrt.
	component: () => <div>Authenticated</div>,
})
